import PropTypes from "prop-types";
import IconBase from "./IconBase";

// Paired with ListIcon as the card/row view toggle.
const GridIcon = ({ toggleColor, ...props }) => (
    <IconBase style={toggleColor ? { color: toggleColor } : undefined} {...props}>
        <rect x="3" y="3" width="8" height="8" rx="2.5" />
        <rect x="13" y="3" width="8" height="8" rx="2.5" />
        <rect x="3" y="13" width="8" height="8" rx="2.5" />
        <rect x="13" y="13" width="8" height="8" rx="2.5" />
    </IconBase>
);

GridIcon.propTypes = {
    toggleColor: PropTypes.string,
};

export default GridIcon;
